import { useSelector } from "react-redux";
import ActivityMainFrame from "../../../../../Components/Activity/ActivityMainFrame/activity-main-frame";
import { ActivityKind } from "../../../../../Core/Api/Types/activity-kind";
import { GetObject } from "../../../../../Redux/Reducers/redux-slice-asset";
import { Container } from "@mui/material";

function AssetSingleActivities() {
  const currentObj = useSelector(GetObject);

  return <ActivityMainFrame kind={ActivityKind.Asset} resourceId={currentObj?.id!} />;
}

export default AssetSingleActivities;
